var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UniqueUserId } from '@xylabs/pixel';
import { AddressInfo } from '../useAddressInfo';
import { Cart, CartItemSlot } from '../useCart';
import { ContactInfo } from '../useContactInfo';
import CoinUserEventHandlerBase from './CoinUserEventHandlerBase';
import FacebookEvents from './Facebook';
import TestData from './TestData';
class FacebookEventHandler extends CoinUserEventHandlerBase {
    constructor() {
        super(...arguments);
        this.events = new FacebookEvents();
    }
    emailCollected() {
        throw new Error('Method not implemented.');
    }
    accountCreated() {
        throw new Error('Method not implemented.');
    }
    shareCompleted() {
        throw new Error('Method not implemented.');
    }
    buyticketsCompleted() {
        throw new Error('Method not implemented.');
    }
    installCompleted() {
        throw new Error('Method not implemented.');
    }
    funnelCompleted() {
        throw new Error('Method not implemented.');
    }
    offerRequested(_fields) {
        throw new Error('Method not implemented.');
    }
    feedbackScoreCollected(_fields) {
        throw new Error('Method not implemented.');
    }
    feedbackSourceCollected(_fields) {
        throw new Error('Method not implemented.');
    }
    goodFeedbackRequested() {
        throw new Error('Method not implemented.');
    }
    badFeedbackRequested() {
        throw new Error('Method not implemented.');
    }
    contactInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = ContactInfo.get().getSanitizedData();
            yield this.events.contactInfoComplete().send(this.buildCustomProperties(data));
        });
    }
    addressInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events
                .addressInfoComplete()
                .send(this.buildCustomProperties(AddressInfo.get().getData()));
        });
    }
    paymentInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.paymentInfoComplete().send(this.buildCustomProperties());
        });
    }
    addToCart() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.addToCart().send(this.buildCartProperties());
        });
    }
    purchaseCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.transactionCompleted().send(this.buildCustomProperties());
        });
    }
    userClick(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.userClick().send(this.buildCustomProperties(fields));
        });
    }
    initiateCheckout() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.initiateCheckout().send(this.buildCartProperties());
        });
    }
    purchaseAttempted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.transactionAttempted().send(this.buildCustomProperties());
        });
    }
    purchaseFailed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.transactionFailed().send(this.buildCustomProperties());
        });
    }
    upsellViewed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.upsellViewed().send(this.buildCustomProperties());
        });
    }
    upsellUnavailable() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.upsellUnavailable().send(this.buildCustomProperties());
        });
    }
    upsellAccepted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.upsellAccepted().send(this.buildCustomProperties());
        });
    }
    upsellSucceeded() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.upsellSucceeded().send(this.buildCustomProperties());
        });
    }
    trialStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.trialStarted().send(this.buildCustomProperties());
        });
    }
    upsellFailed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.upsellFailed().send(this.buildCustomProperties());
        });
    }
    viewContent(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events
                .viewContent()
                .send(this.buildCustomProperties({ content_category: fields.name }));
        });
    }
    testStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.testStarted().send(this.buildCustomProperties());
        });
    }
    funnelStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.funnelStarted().send(this.buildCustomProperties());
        });
    }
    buildCartProperties(data) {
        var _a;
        const content_ids = [];
        const contents = [];
        const cart = Cart.get();
        for (const item of (_a = cart === null || cart === void 0 ? void 0 : cart.getItems()) !== null && _a !== void 0 ? _a : []) {
            content_ids.push(item.planId);
            contents.push({
                id: item.planId,
                quantity: 1,
            });
        }
        return Object.assign(Object.assign(Object.assign(Object.assign({}, data), this.buildValueProperties(data)), this.buildContentProperties(data)), { content_ids,
            contents, num_items: content_ids.length });
    }
    buildUpsellProperties(data) {
        var _a;
        const content_ids = [];
        const contents = [];
        const item = Cart.get().getItemsBySlot(CartItemSlot.Upsell);
        if (item) {
            content_ids.push(item.planId);
            contents.push({
                id: item.planId,
                quantity: 1,
            });
        }
        return Object.assign(Object.assign(Object.assign({}, data), this.buildContentProperties(data)), { content_ids,
            contents, currency: 'USD', num_items: content_ids.length, value: (_a = item === null || item === void 0 ? void 0 : item.value) !== null && _a !== void 0 ? _a : 0 });
    }
    buildContentProperties(data) {
        const cart = Cart.get();
        return Object.assign(Object.assign(Object.assign({}, data), this.buildCustomProperties(data)), { content_name: cart.getItemSet(), content_type: 'product' });
    }
    buildValueProperties(data) {
        const cart = Cart.get();
        return Object.assign(Object.assign(Object.assign({}, data), this.buildCustomProperties(data)), { currency: 'USD', value: cart.getValue() });
    }
    buildCustomProperties(data) {
        const cart = Cart.get();
        const coinId = new UniqueUserId().id;
        const testData = new TestData().data;
        return Object.assign(Object.assign({}, data), { coinId, itemSet: cart.getItemSet(), testData });
    }
}
export default FacebookEventHandler;
